export default __webpack_public_path__ + "static/media/photo--lg--28.ebf55f5e.jpg";